var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadCloud(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.833 45.3333C18.5076 45.3355 15.3013 44.095 12.8434 41.8551C10.3854 39.6153 8.85317 36.5378 8.54728 33.2264C8.24139 29.9151 9.18394 26.609 11.19 23.9567C13.196 21.3045 16.1208 19.4976 19.3903 18.8906C19.9646 15.8337 21.5891 13.0737 23.9829 11.0877C26.3767 9.10174 29.3893 8.01477 32.4997 8.01477C35.61 8.01477 38.6226 9.10174 41.0164 11.0877C43.4102 13.0737 45.0347 15.8337 45.609 18.8906C48.8676 19.51 51.7786 21.3212 53.7739 23.9709C55.7692 26.6207 56.7057 29.9188 56.4006 33.2217C56.0954 36.5246 54.5707 39.5953 52.1237 41.8347C49.6768 44.074 46.4833 45.3214 43.1663 45.3333M24.4997 32L32.4997 24M32.4997 24L40.4997 32M32.4997 24V56",
    stroke: "#00326F",
    strokeWidth: 5.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloud);
export default __webpack_public_path__ + "static/media/upload_cloud.35a0f911.svg";
export { ForwardRef as ReactComponent };